import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/sapling/sapling/node_modules/.pnpm/next@15.5.9_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
